export enum TabStatus {
    normal = "normal",
    locked = "locked",
    done = "done",
    doneEditable = "doneEditable"
}